var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"payment-calculator-template"},[(_setup.canRender)?_c(_setup.Steps,{attrs:{"allowedSteps":_setup.stepsRequired,"application":_setup.application,"component":_setup.components[_setup.route.name]}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }